import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { FuseConfigService } from './../../../@fuse/services/config.service';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
@Component({
  templateUrl: './error-404.component.html',
  styleUrls: ['./error-404.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class Error404Component implements OnInit, OnDestroy {

  private readonly subscriptions = new Subject<void>();

  constructor(
    private fuseTranslationLoaderService: FuseTranslationLoaderService,
    private readonly fuseConfigService: FuseConfigService,
    private readonly router: Router) {

    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });

    this.fuseConfigService.config = {
      layout: {
        navbar: {
          hidden: true
        },
        toolbar: {
          hidden: true
        },
        footer: {
          hidden: true
        },
        sidepanel: {
          hidden: true
        }
      }
    };
  }
  ngOnDestroy(): void {
    this.subscriptions.next();
    this.subscriptions.complete();
  }

  ngOnInit(): void {
    this.router.events
      .pipe(takeUntil(this.subscriptions))
      .pipe(filter((event) => {
        if (!(event instanceof NavigationEnd)) {
          return false;
        }

        return event.urlAfterRedirects === '/404';
      }))
      .subscribe(() => {
        this.fuseConfigService.config = {
          layout: {
            navbar: {
              hidden: true
            },
            toolbar: {
              hidden: true
            },
            footer: {
              hidden: true
            },
            sidepanel: {
              hidden: true
            }
          }
        };
      });
  }

}
